import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useHistory } from "react-router-dom";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FoodOrderTimeLine from "../FoodOrderTimeLine";
import FoodOrderStatus from "../FoodOrderStatus";
import {httpClient} from "../../core/HttpClient";
import {Context} from "../../core/Context";

export default function FoodOrder() {
    const { t } = useTranslation();
    const { id } = useParams();
    const history = useHistory();
    const [context, setContext] = useContext(Context);
    const [foodOrder, setFoodOrder] = useState(null);
    console.log('FoodOrder');
    useEffect(() => {
        httpClient.get(process.env.REACT_APP_API_BASE_URL + '/riders/orders/'+id)
            .then(res => {
                if(res.data && res.status === 200){
                    setFoodOrder(res.data);
                }
            }).catch(err => {
        });
    }, [id]);

    const handleBack = () => {
        history.push('/orders');
    };

    const handleReload = () => {
        let _newContext = { ...context,loading: true};
        setContext(_newContext);
        httpClient.get(process.env.REACT_APP_API_BASE_URL + '/riders/orders/'+id)
            .then(res => {
                if(res.data && res.status === 200){
                    setFoodOrder(res.data);
                    let _newContext = { ...context,loading: false};
                    setContext(_newContext);
                }
            }).catch(err => {
        });
    };

    return (
        <div>
            <Box display="flex" alignItems="center">
                <IconButton edge="start" color="primary" aria-label="black" onClick={handleBack}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6">
                    {t('orders.title')}
                </Typography>
            </Box>
            <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
            {foodOrder &&
            <>
                <FoodOrderStatus value={foodOrder} />
                <FoodOrderTimeLine value={foodOrder} reload={handleReload} />
            </>
            }
        </div>
    );
}
